var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"onToggle":_vm.onToggle,"open":_vm.open})],2)}
var staticRenderFns = []

export { render, staticRenderFns }